import { post } from 'axios'
import store from './../../store/index.js'

const BASE_URL = store.state.api.baseUrl
const headers = { Authorization: `Bearer ${store.state.user.attributes.token}` }

function programSeasonParticipantRegister (pFormData, pIdProgramSeasonPostulant) {
    const URI = `${BASE_URL}/api/registerProgramSeasonParticipant/by/${pIdProgramSeasonPostulant}`
    return post(URI, pFormData ,{ headers })
}
export {
    programSeasonParticipantRegister
}